// [NEW FILE] PM-15 / PM-16: HR reviews an employee's goals next to their KRAs and KPIs, and (with the new backend,
// REACT_APP_BACKEND_REVIEWER_GOAL_EDIT=true) corrects a goal with a reason. HR never adds goals.
// The backend lets HR edit while the goal sheet is not yet approved (draft, waiting for approval, changes requested).
import { Card, Banner, Loader } from "../../../components/common";
import GoalList from "../../../components/goals/GoalList";
import useReviewerGoalEdit, { REVIEWER_GOAL_EDIT } from "../../../components/goals/ReviewerGoalEdit";
import useAsync from "../../../hooks/useAsync";
import { getEmployeeGoalSheet } from "../../../services/goalApi";
import { SHEET_STATUS } from "../../../utils/constants";

const EDITABLE = [SHEET_STATUS.DRAFT, SHEET_STATUS.PENDING, SHEET_STATUS.CHANGES_REQUESTED];

export default function HrGoalReviewCard({ cycle, employeeId, employeeName }) {
  const sheet = useAsync(() => getEmployeeGoalSheet(cycle.id, employeeId), [cycle?.id, employeeId], { skip: !cycle?.id || !employeeId });
  const data = sheet.data;
  const editable = Boolean(data) && EDITABLE.includes(data.sheetStatus);
  const goalEdit = useReviewerGoalEdit({
    goals: data?.goals || [], editedAs: "HR", employeeName, cycle, enabled: editable, onSaved: sheet.reload,
  });

  let subtitle = "Goals the employee added. HR reviews them; HR does not add goals.";
  if (data && REVIEWER_GOAL_EDIT) {
    subtitle = editable
      ? "You can correct a goal with a reason. The employee and manager see the change in the history."
      : `The goal sheet is ${String(data.sheetStatus).toLowerCase()}. Approved goals change only through the employee's change request.`;
  }

  return (
    <Card title="Goals" subtitle={subtitle} padded={false}>
      {sheet.loading && !data && <Loader />}
      {sheet.error && <div style={{ padding: 16 }}><Banner tone="danger" title="Couldn't load goals">{sheet.error}</Banner></div>}
      {data && (
        <GoalList
          goals={data.goals}
          showAchievement={data.sheetStatus === SHEET_STATUS.APPROVED}
          renderActions={goalEdit.active ? goalEdit.action : undefined}
          emptyTitle="No goals yet"
          emptyText="The employee has not added goals in this cycle."
        />
      )}
      {goalEdit.element}
    </Card>
  );
}
